import { useContext } from 'react';

import { Modal, ModalTrigger, Paragraph, TextButton } from '@zillow/constellation-10';

import { RMWContext } from '../../../../providers/RMWContext';

import { PropertiesSelectors, UserSelectors } from '../../../../selectors';
import { useSelector } from '../../../../selectors/useSelector';

import emailUtils from '../../../../utils/emailUtils';

import { StyledHR } from '../styles';

const FixIncorrectInformationModal = () => {
  const { paths } = useContext(RMWContext);

  const { topDupesDetails, isMultifamily } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));
  const { isMultifamilyCustomer, isSingleFamilyEnterpriseCustomer } = useSelector((state) =>
    UserSelectors.makeUser(state),
  );
  const email = emailUtils.getHelpEmail(isMultifamily && isMultifamilyCustomer, isSingleFamilyEnterpriseCustomer);
  const hasManualDupe = topDupesDetails && topDupesDetails.hasManualDupe;

  const handleGoToManualListing = () => {
    const { topDupeManualListingAlias } = topDupesDetails;
    const url = `${paths.propertiesPage}/${topDupeManualListingAlias}/${paths.propertyDetailsListing}`;
    window.router.transitionTo(url);
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  let title = 'Automatically create a new version in Zillow Rental Manager';
  let text = `We’ll make an editable copy of the listing. You can change it in Zillow Rental Manager,
        then publish the new listing.`;
  let cta = 'Fix listing';
  let ctaClick = null;

  if (hasManualDupe) {
    title = 'Update your listing in Zillow Rental Manager';
    text = 'Go to the Zillow Rental Manager version of the listing, update fields and then publish the listing.';
    cta = 'Update your listing';
    ctaClick = handleGoToManualListing;
  }

  const renderCta = () => <TextButton onClick={() => ctaClick?.()}>{cta}</TextButton>;

  return (
    <>
      <Paragraph css={{ textStyle: 'heading-sm' }}>{title}</Paragraph>
      <Paragraph css={{ marginBlock: '400' }}>{text}</Paragraph>
      <Modal.Close>
        {!hasManualDupe ? (
          <ModalTrigger multiModalTriggerId="TransferFeedListingModal">{renderCta()}</ModalTrigger>
        ) : (
          renderCta()
        )}
      </Modal.Close>
      <StyledHR color="yellow300" />
      <Paragraph css={{ textStyle: 'heading-sm' }}>Or you can contact support</Paragraph>
      <Paragraph css={{ marginBlock: '400' }}>Get help with questions about your listing.</Paragraph>
      <Modal.Close>
        <TextButton onClick={handleEmailClick}>Email Zillow support</TextButton>
      </Modal.Close>
    </>
  );
};

export { FixIncorrectInformationModal };
export default FixIncorrectInformationModal;
